function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.53834 1.41194C8.70914 1.0013 9.29086 1.0013 9.46166 1.41194L10.9488 4.98748C11.1648 5.50683 11.6532 5.86169 12.2139 5.90664L16.074 6.2161C16.5173 6.25164 16.6971 6.80489 16.3593 7.09423L13.4184 9.61349C12.9912 9.97942 12.8046 10.5536 12.9351 11.1007L13.8336 14.8675C13.9368 15.3001 13.4662 15.642 13.0867 15.4102L9.78188 13.3917C9.30186 13.0985 8.69814 13.0985 8.21812 13.3917L4.91334 15.4102C4.53379 15.6421 4.06317 15.3001 4.16636 14.8675L5.06488 11.1007C5.19539 10.5536 5.00883 9.97942 4.58165 9.61349L1.64067 7.09423C1.3029 6.80489 1.48266 6.25164 1.92599 6.2161L5.78608 5.90663C6.34677 5.86169 6.83518 5.50683 7.05119 4.98748L8.53834 1.41194Z",
  stroke: "#FEFEFE"
});

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.049acf64.svg";
export { ForwardRef as ReactComponent };